// Entry point for the build script in your package.json

require("bootstrap");
require("@hotwired/turbo-rails");

require("./controllers");
require("./lib");
